<template>
  <div>
    <div v-if="buildingComponent">
      <!-- <v-toolbar dense flat class="sticky-toolbar-breadcrumb"> -->
      <v-toolbar elevation="1" dark dense color="highlight" flat class="sticky-toolbar-breadcrumb">
        <v-toolbar-title v-if="buildingComponent">{{buildingComponent.name}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <!-- <can I="update" a="buildingComponents"> -->
        <editBuildingComponent
          v-on:edit="editBuildingComponent"
          :buildingComponent="buildingComponent"
        />
        <!-- </can> -->
      </v-toolbar>
      <div v-bind:class="!$vuetify.breakpoint.lgAndUp ? 'container': ''">
        <!-- <v-card class="mb-3 mt-3">
          <v-container>
            <div class="subheader">{{$t("description")}}</div>
            <p class="body-1">{{buildingComponent.description}}</p>
          </v-container>
        </v-card>-->

        <v-toolbar elevation="1" class="mt-3" dense flat>
          <v-toolbar-title>{{$t('blueprints')}}</v-toolbar-title>

          <v-spacer></v-spacer>
          <can I="create" a="blueprints">
            <addBlueprint v-on:add-blueprint="addBlueprint"></addBlueprint>
          </can>
        </v-toolbar>

        <dataTable v-on:clickItem="blueprintDetails" :items="blueprints" :progress="progress" :headers="headers">
          <template v-slot:itemAction="{item}">
            <v-btn
              class="ml-3 mr-2"
              color="primary"
              :disabled="!$can('delete', 'projects') && item.isLocked"
              v-if="($can('delete', 'projects') && !item.isLocked) || (!$can('delete', 'projects'))"
              icon
              @click.stop="editBlueprint(item)"
            >
              <v-icon color="primary">fa-edit</v-icon>
            </v-btn>
            <v-btn
              class="ml-3 mr-2"
              color="primary"
              v-if="$can('delete', 'projects') && item.isLocked"
              icon
              @click.stop="breakLock(item)"
            >
              <v-icon color="primary">fa-lock</v-icon>
            </v-btn>
            <!-- Bart, 12/2/20: if locked show lock icon (which allows to break the lock) to administrators, if not administrator just show disabled edit icon -->
            <v-menu transition="scale-transition" origin="right top" style="z-index: 10" class="white" :close-on-content-click="false" bottom left>
              <template v-slot:activator="{ on }">
                <v-btn @click.prevent @click.stop color="primary" icon v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-sheet flatwidth="300px">
                <v-list dense>
                  <can I="download" a="excel">
                    <v-list-item @click.stop="downloadExcel(item)">
                      <v-list-item-icon>
                        <v-icon color="success">fa-file-excel</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>{{$t('download')}}</v-list-item-content>
                    </v-list-item>
                  </can>
                  <can I="delete" a="blueprints">
                    <areyousure
                      list_item
                      v-on:delete="deleteBlueprint"
                      :id="item.id"
                      object="blueprint"
                    ></areyousure>
                  </can>
                </v-list>
              </v-sheet>
            </v-menu>
          </template>
          <template v-slot:cardContent="{item}">
            <v-subheader class="primary lighten-3 white--text font-weight-bold">
              <a href="#" class="white--text" @click="blueprintDetails(item)">{{item.name }}</a>
              <v-spacer></v-spacer>
              <v-menu transition="scale-transition" origin="right top" style="z-index: 10" class="white" :close-on-content-click="false" bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn @click.prevent @click.stop color="primary" icon v-on="on">
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-sheet flat>
                  <v-list dense>
                    <can I="download" a="excel">
                      <v-list-item @click.stop="downloadExcel(item)">
                        <v-list-item-icon>
                          <v-icon color="success">fa-file-excel</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>{{$t('download')}}</v-list-item-content>
                      </v-list-item>
                    </can>
                    <!-- download logbook from blueprint detail page -->
                    <!-- <can I="download" a="logbook">
                              <v-list-item @click.stop="downloadLogbook(item)">
                                <v-list-item-icon>
                                  <v-icon color="primary">import_contacts</v-icon>
                                </v-list-item-icon>
                                <v-list-item-content>{{$t('download')}}</v-list-item-content>
                              </v-list-item>
                    </can>-->
                    <can I="delete" a="blueprints">
                      <areyousure
                        list_item
                        v-on:delete="deleteBlueprint"
                        :id="item.id"
                        object="blueprint"
                      ></areyousure>
                    </can>
                  </v-list>
                </v-sheet>
              </v-menu>
            </v-subheader>

            <v-divider></v-divider>
            <div v-ripple class="pointer" @click="blueprintDetails(item)">
              <v-list dense>
                <v-list-item>
                  <v-list-item-content>{{$t('description')}}:</v-list-item-content>
                  <v-list-item-content
                    class="align-end font-weight-bold text-truncate"
                  >{{ item.description }}</v-list-item-content>
                </v-list-item>

                <v-list-item>
                  <v-list-item-content>{{$t('markers')}}:</v-list-item-content>
                  <v-list-item-content class="align-end font-weight-bold">{{ item.markers.length }}</v-list-item-content>
                </v-list-item>
                <v-list-item v-if="item.isLocked">
                  <v-list-item-content>{{$t('isEditing')}}:</v-list-item-content>
                  <v-list-item-content
                    class="align-end font-weight-bold"
                  >{{ item.lockedByUserName }}</v-list-item-content>
                </v-list-item>
                <v-list-item v-if="item.isLocked">
                  <v-list-item-content>{{$t('editStart')}}:</v-list-item-content>
                  <v-list-item-content class="align-end font-weight-bold">{{ item.lockedTs }}</v-list-item-content>
                </v-list-item>

                <v-list-item v-if="$can('delete', 'projects') && item.isLocked">
                  <v-list-item-content>{{$t('breakLock')}}:</v-list-item-content>
                  <v-list-item-content
                    @click.stop="breakLock(item)"
                    class="align-end font-weight-bold"
                  >
                    <a href="#">
                      {{$t('break')}}
                      <i class="fa fa-lock ml-2"></i>
                    </a>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
          </template>
          <template v-slot:empty>
            <retry v-on:retry="getData()" v-if="retry"></retry>
            <emptyList
              fit
              :image="require('@/assets/blueprint_logo_low_opacity.png')"
              :title="$t('noBlueprints')"
              v-else
            >
              <template v-slot:action>
                <can I="create" a="blueprints">
                  <addBlueprint v-on:add-blueprint="addBlueprint"></addBlueprint>
                </can>
              </template>
            </emptyList>
          </template>
        </dataTable>

        <v-dialog v-model="dialog" persistent max-width="290">
          <v-card>
            <v-card-title class="headline">{{$t('warning')}}</v-card-title>
            <v-card-text>{{$t('continuereadonly')}}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text autofocus @click="responseReadonly(false)">{{$t('no')}}</v-btn>
              <v-btn color="primary" text @click="responseReadonly(true)">{{$t('yes')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <loadingDialog :dialog="loading"></loadingDialog>
    </div>
    <div v-else>
      <v-container fill-height>
        <loading></loading>
      </v-container>
    </div>
  </div>
</template>

<script>
import retry from "@/components/Retry";
import emptyList from "@/components/EmptyList";
import blueprints from "@/components/pages/Blueprints/Blueprints";
import addBlueprint from "@/components/pages/Blueprints/AddBlueprint";
import jwtdecode from "jwt-decode";
import editBuildingComponent from "@/components/pages/BuildingComponents/EditBuildingComponent";
import dataTable from "@/components/Datatable";

export default {
  name: "BuildingComponentsDetails",
  components: {
    editBuildingComponent,
    blueprints,
    addBlueprint,
    retry,
    emptyList,
    dataTable
  },
  data() {
    return {
      progress: true,
      buildingComponent: null,
      blueprints: [],
      headers: [],
      loading: false,
      response: false,
      dialog: false,
      readonlyblueprint: null,
      search: "",
      sortBy: "name",
      sortDesc: false,
      retry: false
    };
  },
  computed: {},
  watch: {
    headers() {
      this.$forceUpdate();
    },
    blueprints(n, o) {
      if (n.length > 0) {
        if (this.blueprints.some(x => x.isLocked)) {
          this.headers = [
            {
              text: this.$t("name"),
              align: "left",
              value: "name"
            },
            {
              text: this.$t("description"),
              align: "left",
              value: "description"
            },
            {
              text: this.$t("markers"),
              value: "markers.length"
            },
            {
              text: this.$t("isEditing"),
              value: "lockedByUserName"
            },
            {
              text: this.$t("editStart"),
              value: "lockedTs"
            },
            { text: this.$t("actions"), sortable: false, value: "actions" }
          ];
        } else {
          this.headers = [
            {
              text: this.$t("name"),
              align: "left",
              value: "name"
            },
            {
              text: this.$t("description"),
              align: "left",
              value: "description"
            },
            {
              text: this.$t("markers"),
              value: "markers.length"
            },
            { text: this.$t("actions"), sortable: false, value: "actions" }
            //{ text: this.$t("table.markUp"), sortable: false }
          ];
        }
      }
    },
    buildingComponent(n, o) {
      if (n) {
        if (n.isArchived) {
          this.$router.push({
            name: "ArchivedBuildingComponentDetails",
            params: { id: n.id }
          });
        }
      }
    }
  },
  methods: {
    breakLock(blueprint) {
      this.$http
        .lockBlueprint(blueprint.id, true)
        .then(res => {
          let i = this.blueprints.findIndex(p => p.id === blueprint.id);
          let markers = this.blueprints[i].markers;
          res.data.markers = markers;
          this.blueprints[i] = res.data;
          this.blueprints = this.blueprints.slice(); //Bart, 13/2/20: clone to trigger vue
        })
        .catch(err => {
          console.log(err);
          this.$noty.error(this.$t("error"));
        });
    },
    downloadExcel(blueprint) {
      this.loading = true;
      this.$http
        .downloadExcelExport(null, null, blueprint.id)
        .then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          let date = new Date();
          link.setAttribute(
            "download",
            `${blueprint.name}_${date.toLocaleDateString()}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.$noty.error(this.$t("error"));
          this.loading = false;
        });
    },
    addBlueprint(newBlueprint) {
      this.$http
        .addBlueprint(newBlueprint)
        .then(res => {
          this.blueprints.push(res.data);
          this.$noty.success('<i class="fas fa-check"></i>');
        })
        .catch(err => {
          this.$noty.error(err);
          console.log(err);
        });
    },
    editBlueprint(item) {
      if (this.$can("update", "markers")) {
        if (
          jwtdecode(localStorage.getItem("auth")).contactId !=
          item.lockedByUserId
        ) {
          this.$http
            .lockBlueprint(item.id)
            .then(res => {
              if (item.lockedByUserName !== null) {
                this.dialog = true;
                this.readonlyblueprint = item;
              } else {
                this.editBlueprintDetails(item);
              }
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
            });
        } else {
          this.editBlueprintDetails(item);
        }
      } else {
        this.blueprintDetails(item);
      }
    },
    editBuildingComponent(buildingComponent) {
      this.$http
        .updateBuildingComponent(buildingComponent)
        .then(res => {
          this.$noty.success('<i class="fas fa-check"></i>');
        })
        .catch(err => {
          this.$noty.error(this.$t("error"));
          console.log(err);
        });
    },
    responseReadonly(yes) {
      if (yes) {
        this.dialog = false;
        if (this.readonlyblueprint)
          this.blueprintDetails(this.readonlyblueprint, true);
      }
      this.readonlyblueprint = null;
      this.dialog = false;
    },
    deleteBlueprint(id) {
      this.blueprints = this.blueprints.filter(p => p.id != id);
    },
    editBlueprintDetails(item, editable) {
      this.$router.push({
        name: "EditBlueprintsDetails",
        params: { id: item.id }
      });
    },
    blueprintDetails(item) {
      this.$router.push({
        name: "BlueprintsDetails",
        params: {
          id: item.id
        }
      });
    },
    makeBreadcrumb() {
      this.$store.state.breadcrumb = [
        {
          name: this.$t("projects"),
          to: { name: "Projects" }
        },
        {
          name: this.buildingComponent.project,
          to: {
            name: "ProjectDetails",
            params: { id: this.buildingComponent.projectId }
          }
        },
        {
          name: this.buildingComponent.name
        }
      ];
    },
    getData() {
      this.progress = true;
      this.$http
        .getBuildingComponent(this.$route.params.id)
        .then(res => {
          this.buildingComponent = res.data;
          this.$store.state.previous = {
            name: "ProjectDetails",
            id: res.data.projectId,
            breadcrumb: this.$t("project")
          };
          this.makeBreadcrumb();
        })
        .catch(err => console.log(err));

      this.$http
        .getBlueprints(this.$route.params.id)
        .then(res => {
          this.blueprints = res.data;
          this.progress = false;
          this.retry = false;
        })
        .catch(err => {
          console.log(err);
          this.progress = false;
          this.retry = true;
        });
    }
  },
  created() {
    this.getData();
  }
};
</script>


// WEBPACK FOOTER //
// src/views/buildingComponents/BuildingComponentsDetails.vue